<template>
    <div class="logo_box" v-loading="loading">
        <div class="logo_center_box">
            <div class="center_top">
                <span v-show="!isLogin">
                    <img src="/static/imge/logo/btn_cancel.png @2x.png" @click="isLogin = true" />
                </span>
                <span>{{title}}</span>
                <!-- <span>
                    <img src="/static/imge/logo/narrow@2x.png" />
                    <img src="/static/imge/logo/close@2x.png" />
                </span> -->
            </div>
            <!-- 密码和扫码登录 -->
            <div class="login" v-show="isLogin">
                <div class="center_center">
                    <div class="logoTabl">
                        <span
                            :class="isScanCodeLogin ? 'logoAction' : ''"
                            @click="isScanCodeLogin = !isScanCodeLogin"
                        >扫码登录</span>
                        <span
                            :class="!isScanCodeLogin ? 'logoAction' : ''"
                            @click="isScanCodeLogin = !isScanCodeLogin"
                        >密码登录</span>
                    </div>
                    <!-- 扫码登录 -->
                    <div class="scanCode" v-show="isScanCodeLogin">
                        <!-- <img src="" alt=""> -->
                        <div class="codeImg">
                            <div class="maskDiv" v-if="codeChange">
                                <div v-if="changeLogin">
                                    <p>扫码成功,页面即将跳转</p>
                                </div>
                                <div v-if="changeReload">
                                    <p>请重新刷新二维码</p>
                                    <el-button type="primary" @click="getQRCode">点击刷新</el-button>
                                </div>
                            </div>
                            <canvas id="QRCode"></canvas>
                        </div>
                        <span>手机企管邦扫码登录</span>
                    </div>
                    <!-- 密码登录 -->
                    <div class="password" v-show="!isScanCodeLogin">
                        <img class="logo" src="/static/imge/logo/logo@2x.png" />
                        <div class="password_form">
                            <li>
                                <img src="/static/imge/logo/shoujihao@2x.png" />
                                <el-input
                                    v-model="passwordLoginObj.phoneNumber"
                                    placeholder="请输入手机号"
                                    oninput="if(value.length>11)value=value.slice(0,11)"
                                    type="number"
                                ></el-input>
                            </li>
                            <li class="password_input">
                                <img src="/static/imge/logo/mima@2x.png" />
                                <el-input
                                    placeholder="请输入密码"
                                    v-model="passwordLoginObj.passwordNumber"
                                    :minlength="6"
                                    show-password
                                    @keyup.enter.native="loginFun"
                                ></el-input>
                                <img
                                    class="denglu"
                                    @click="loginFun"
                                    src="/static/imge/logo/denglv@2x.png"
                                />
                            </li>
                        </div>
                    </div>
                </div>
                <div class="center_bottom">
                    <span>
                        <label>
                             <el-checkbox v-model="autoLogo">自动登录</el-checkbox>
                            <!-- <input type="checkbox" :name="autoLogo" />&nbsp;自动登录 -->
                        </label>
                    </span>
                    <div class="rightFunction">
                        <span v-show="!isScanCodeLogin" @click="rightFunctionClick('forget')">忘记密码</span>
                        <!-- <span @click="rightFunctionClick('register')">新用户注册</span> -->
                    </div>
                </div>
            </div>
            <!-- 找回密码和注册用户 -->
            <div class="RPRU" v-show="!isLogin">
                <div class="RPRU_top">
                    <div>
                        <p>{{RPRUTitle}}</p>
                        <p v-show="rightFunctionType == 'seting'">至少6个字符，数字、字母、符号</p>
                    </div>
                </div>
                <div class="RPRU_bottom">
                    <!-- 手机号验证码 -->
                    <div class="phoneAndcode" v-show="isRegister">
                        <li>
                            <img src="/static/imge/logo/shoujihao@2x.png" />
                            <el-input v-model="phoneCode.phoneNumber" placeholder="请输入手机号"></el-input>
                        </li>
                        <li class="fasongyanzm">
                            <el-input v-model="phoneCode.code" placeholder="请输入验证码"></el-input>
                            <span
                                class="fasong"
                                v-show="verificationCode"
                                @click="sendeVerificationCode"
                            >发送验证码</span>
                            <span class="countDown" v-show="!verificationCode">{{countDown}}s</span>
                        </li>
                    </div>
                    <!-- 密码设置 -->
                    <div class="mimaSeting" v-show="!isRegister">
                        <li>
                            <span>登录密码</span>
                            <el-input v-model="passwordseting.loginPassword" placeholder="请输入密码"></el-input>
                        </li>
                        <li>
                            <span>确认密码</span>
                            <el-input v-model="passwordseting.confirmPassword" placeholder="请确认密码"></el-input>
                        </li>
                    </div>
                    <span class="submtButton" @click="registerAndConfirm">{{registerAndConfirmStr}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExampleApi from "@/api/ExampleApi";
import QRCode from "qrcode";
export default {
    data() {
        return {
            title: "企管邦",
            autoLogo: true,
            countDown: 60,
            // 登录和注册切换
            isLogin: true,
            // 扫码登录和密码登录切换
            isScanCodeLogin: true,
            // 发送验证码节流阀
            verificationCode: true,
            // 找回密码还是注册新用户
            rightFunctionType: "",
            // 找回密码和注册用户标题
            RPRUTitle: "",
            // 定时器
            timeserver: null,
            // 密码登录
            passwordLoginObj: {
                // 手机号
                phoneNumber: "",
                // 密码
                passwordNumber: ""
            },
            // 手机验证码
            phoneCode: {
                // 手机号
                phoneNumber: "",
                // 验证码
                code: ""
            },
            // 密码设置
            passwordseting: {
                // 登录密码
                loginPassword: "",
                // 确认密码
                confirmPassword: ""
            },
            // 注册和确认显示
            isRegister: true,
            registerAndConfirmStr: "注册",
            loading: null,
            QRCodeMsg: "", //
            uuid: "",
            timeId: null, //定时器
            forgetCode: "", //忘记密码验证码
            registerCode: "", //忘记密码验证码
            codeChange: false,
            changeLogin: false,
            changeReload: false,
            qrcodeNumber: 0,
            loading: false
        };
    },
    mounted() {
        if (localStorage.getItem("resData")) {
            let data = JSON.parse(localStorage.getItem("resData"));
            localStorage.setItem("token", data.token);
            this.$store.dispatch("connect", {
                type: "nim",
                imOptions: {
                    account: data.imAccount,
                    token: data.imToken
                }
            });
            this.$store.commit("update_userUID", data.imAccount);
            this.$router.push({
                path: "/home/chatIndex"
            });
        } else {
            localStorage.removeItem("token");
            this.getQRCode();
        }
    },
    methods: {
        rightFunctionClick(type) {
            let self = this;
            self.isLogin = false;
            self.isRegister = true;
            self.rightFunctionType = type;
            if (self.rightFunctionType == "forget") {
                self.RPRUTitle = "密码找回";
                self.registerAndConfirmStr = "确定";
            } else if (self.rightFunctionType == "register") {
                self.RPRUTitle = "欢迎使用企管邦";
                self.registerAndConfirmStr = "注册";
            }
        },
        async generateUUID() {
            let res = await ExampleApi.createQrCode();
            if (res.code == 200) {
                this.uuid = res.data.key;
                this.QRCodeMsg = res.data.content;
            }
        },
        async timeOutLogin(uuid) {
            let self = this;
            let res = await ExampleApi.queryQRCode({ uuid });
            if (res.code == 200) {
                if (res.data.resourceToken != "") {
                    window.clearInterval(this.timeId);
                    self.codeChange = true;
                    self.changeLogin = true;
                    localStorage.removeItem("token");
                    localStorage.setItem("token", res.data.resourceToken);
                    let iMtoken = await ExampleApi.getCurrentUserInfo();
                    if (iMtoken.code == 200) {
                        res.data.imAccount = iMtoken.data.imAccount;
                        res.data.imToken = iMtoken.data.imToken;
                        localStorage.removeItem("token");
                        localStorage.setItem("token", res.data.jwt);
                        this.uuid = "";
                    }
                    window.clearTimeout(self.timeId);
                    res.data.token = res.data.jwt;
                    if (this.autoLogo) {
                        localStorage.setItem(
                            "resData",
                            JSON.stringify(res.data)
                        );
                    }
                    self.$store.dispatch("connect", {
                        type: "nim",
                        imOptions: {
                            account: res.data.imAccount,
                            token: res.data.imToken
                        }
                    });
                    self.$store.commit("update_userUID", res.data.imAccount);
                    setTimeout(() => {
                        self.$router.push({
                            path: "/home/chatIndex"
                        });
                    }, 1000);
                }
            }
        },
        async getQRCode() {
            this.codeChange = false;
            this.changeReload = false;
            await this.generateUUID();
            this.timeId = setInterval(() => {
                this.qrcodeNumber++;
                if (this.qrcodeNumber == 60) {
                    this.codeChange = true;
                    this.changeReload = true;
                    window.clearInterval(this.timeId);
                }
                this.timeOutLogin(this.uuid);
            }, 1000);
        },
        // 发送验证码
        async sendeVerificationCode() {
            let self = this;
            let data = {
                mobile: self.phoneCode.phoneNumber
            };
            if (self.rightFunctionType == "forget") {
                let res = await ExampleApi.getSendSms(data);
                if (res.state == "ok") {
                    self.verificationCode = !self.verificationCode;
                    self.countDown = 60;
                    self.opentimeOut();
                    self.forgetCode = res.data;
                }
            } else if (self.rightFunctionType == "register") {
                let res = await ExampleApi.getSMSLoginCode(data);
                if (res.state == "ok") {
                    self.verificationCode = !self.verificationCode;
                    self.countDown = 60;
                    self.opentimeOut();
                    self.registerCode = res.data;
                }
            }
        },
        // 开启倒计时定时器
        opentimeOut() {
            let self = this;
            self.timeserver = setInterval(() => {
                if (self.countDown <= 1) {
                    self.verificationCode = true;
                    clearInterval(self.timeserver);
                } else {
                    self.countDown -= 1;
                }
            }, 1000);
        },
        // 注册和确认按钮
        registerAndConfirm() {
            let self = this;
            if (self.isRegister) {
                if (self.rightFunctionType == "forget") {
                    //密码找回第一次点击
                    self.getForgetPass();
                } else if (self.rightFunctionType == "register") {
                    //注册用户第一次点击
                    self.getRegisterCode();
                }
            } else {
                if (
                    !self.passwordseting.confirmPassword &&
                    !self.passwordseting.loginPassword
                ) {
                    this.$message.error("两次密码需全部输入");
                    return false;
                }
                if (
                    self.passwordseting.confirmPassword !==
                    self.passwordseting.loginPassword
                ) {
                    this.$message.error("两次密码输入不一致");
                    return false;
                }
                if (self.rightFunctionType == "forget") {
                    //密码找回第二次点击
                    self.getForgetLast();
                } else if (self.rightFunctionType == "register") {
                    //注册用户第二次点击
                    self.getRegisterLast();
                }
            }
        },
        //密码找回,获取验证码之后第一次点击确定
        getForgetPass() {
            if (!this.phoneCode.phoneNumber) {
                // this.ifGetCode = false
                this.$message.error("请输入电话号码");
                return;
            }
            if (!this.isvalidPhone(this.phoneCode.phoneNumber)) {
                this.$message.error("请输入正确的手机号");
                return;
            }
            let self = this;
            if (this.forgetCode === "") {
                this.$message.error("您未获取验证码");
                return false;
            }
            if (String(this.phoneCode.code) !== this.forgetCode) {
                this.$message.error("验证码有误");
                return false;
            }
            self.isRegister = false;
        },
        async getForgetLast() {
            //mobile（手机号）、password（密码）、code（验证码）
            let res = await ExampleApi.getForgetPass({
                mobile: this.phoneCode.phoneNumber,
                code: this.phoneCode.code,
                password: this.utf8_to_b64(this.passwordseting.confirmPassword)
            });
            if (res.state === "ok") {
                this.isScanCodeLogin = false;
                this.isLogin = true;
            }
        },
        //用户注册,获取验证码之后第一次点击确定
        getRegisterCode() {
            let self = this;
            if (this.registerCode === "") {
                this.$message.error("您未获取验证码");
                return false;
            }
            if (String(this.phoneCode.code) !== this.registerCode) {
                this.$message.error("验证码有误");
                return false;
            }
            if (!this.phoneCode.phoneNumber) {
                this.$message.error("请输入电话号码");
                return;
            }
            if (!this.isvalidPhone(this.phoneCode.phoneNumber)) {
                this.$message.error("请输入正确的手机号");
                return;
            }
            self.isRegister = false;
        },
        async getRegisterLast() {
            //mobile（手机号）、password（密码）、code（验证码）
            let res = await ExampleApi.getRegister({
                userName: this.phoneCode.phoneNumber,
                code: this.phoneCode.code,
                passWord: this.utf8_to_b64(this.passwordseting.confirmPassword)
            });
            if (res.state === "ok") {
                localStorage.setItem("token", res.data.token);
                if (this.autoLogo) {
                    localStorage.setItem("resData", JSON.stringify(res.data));
                }
                self.$store.dispatch("connect", {
                    type: "nim",
                    imOptions: {
                        account: res.data.imAccount,
                        token: res.data.imToken
                    }
                });
                self.$store.commit("update_userUID", res.data.imAccount);
                this.$router.push({
                    path: "/home/chatIndex"
                });
            } else {
                this.$message(res.msg);
            }
        },
        isvalidPhone(str) {
            const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
            return reg.test(str);
        },
        // 登录功能
        async loginFun() {
            let self = this;
            if (!this.passwordLoginObj.phoneNumber) {
                this.$message.error("请输入电话号码");
                return;
            }
            if (!this.isvalidPhone(this.passwordLoginObj.phoneNumber)) {
                this.$message.error("请输入正确的手机号");
                return;
            }
            if (!this.passwordLoginObj.passwordNumber) {
                this.$message.error("请输入密码");
                return;
            }

            if (
                this.passwordLoginObj.passwordNumber &&
                this.passwordLoginObj.passwordNumber.length < 6
            ) {
                this.$message.error("密码最低长度为六位");
                return;
            }
            if (
                this.passwordLoginObj.passwordNumber &&
                this.passwordLoginObj.passwordNumber.length > 16
            ) {
                this.$message.error("密码最长长度为十六位");
                return;
            }
            self.loading = self.$loading({
                lock: true,
                text: "登陆中,即将跳转",
                spinner: "el-icon-loading"
            });
            let res = await ExampleApi.getLogin({
                username: this.passwordLoginObj.phoneNumber,
                password: this.utf8_to_b64(this.passwordLoginObj.passwordNumber)
            });
            if (res.state == "ok") {
                //res.data.imAccount 用户的im账号
                //res.data.imToken
                //res.data.phone 手机号
                //res.data.token 设置所需token
                // localStorage.setItem("token",JSON.stringify({
                //     resourceAPPToken:res.data.resourceAPPToken
                // }));
                localStorage.setItem("token", res.data.token);
                if (this.autoLogo) {
                    localStorage.setItem("resData", JSON.stringify(res.data));
                }
                self.$store.dispatch("connect", {
                    type: "nim",
                    imOptions: {
                        account: res.data.imAccount,
                        token: res.data.imToken
                    }
                });
                self.$store.commit("update_userUID", res.data.imAccount);
                self.loading.close();
                this.$router.push({
                    path: "/home/chatIndex"
                });
            } else if (res.code == 1) {
                self.loading.close();
                this.$message.error("登陆失败,请检查网络");
            }
        },
        utf8_to_b64(str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        },
        // 加载框
        loadingFunction() {
            let self = this;
            self.loading.close();
            self.$router.push({
                path: "home",
                query: {}
            });
        }
    },
    destroyed() {
        window.clearInterval(this.timeId);
    },
    watch: {
        isLogin: val => {
            let self = this;
        },
        "$store.state.loading": function(val) {
            let self = this;
            if (!val) {
                self.loadingFunction();
            }
        },
        QRCodeMsg(val) {
            // 获取页面的canvas
            let msg = document.getElementById("QRCode");
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, val, { width: 200, height: 200 }, function(
                error
            ) {});
        }
    },
    beforeDestroy() {
        window.clearTimeout(this.timeId);
    }
};
</script>

<style scoped>
.logo_box {
    width: 100vw;
    height: 100vh;
    background: #e9f2fd;
    position: relative;
}
.logo_center_box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    width: 350px;
    height: 500px;
    background: #ffffff;
    overflow: hidden;
}
.center_top {
    width: 100%;
    height: 55px;
    line-height: 55px;
    background: #0185df;
    color: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
}
.center_top > img {
    float: left;
    margin-right: 10px;
    width: 8px;
    height: 14px;
}
.center_top span:nth-of-type(1) {
    float: left;
    margin-right: 10px;
    cursor: pointer;
}
.center_top span:nth-of-type(1) img {
    width: 8px;
    height: 14px;
}
.center_top span:nth-of-type(2) {
    font-size: 18px;
    float: left;
}
.center_top span:nth-of-type(3) {
    font-size: 13px;
    float: right;
}
.center_top span:nth-of-type(3) img {
    width: 13px;
    cursor: pointer;
}
.center_top span:nth-of-type(3) img:nth-of-type(1) {
    height: 2px;
    margin-right: 10px;
}
.center_top span:nth-of-type(3) img:nth-of-type(2) {
    height: 13px;
}
.center_center {
    width: 100%;
    height: calc(100% - 155px);
    padding: 14px 35px;
    box-sizing: border-box;
}
.logoTabl {
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: center;
}
.logoTabl span {
    flex: 1;
    cursor: pointer;
    height: 100%;
    color: #999999;
    border-bottom: 1px solid #999999;
    text-align: center;
}
.logoTabl .logoAction {
    color: #0185df;
    border-bottom: 1px solid #0185df;
}
.scanCode,
.password {
    width: 100%;
    height: calc(100% - 36px);
    display: flex;
    flex-direction: column;
    align-items: center;
}
.scanCode .codeImg {
    width: 200px;
    height: 200px;
    margin: 40px 0px;
    cursor: pointer;
    background: #fff;
    position: relative;
}
.maskDiv {
    position: absolute;
    width: 200px;
    height: 200px;
    background-color: rgba(255, 255, 255, 0.9);
    text-align: center;
    line-height: 200px;
}
.maskDiv > div {
    width: 200px;
    height: 200px;
}
.maskDiv > div > p {
    width: 200px;
    height: 30px;
    margin-bottom: 20px;
}
.password .logo {
    width: 102px;
    height: 103px;
    margin: 40px 0px;
}
.password_form,
.RPRU_bottom {
    width: 100%;
}
.password_form li,
.RPRU_bottom .phoneAndcode li {
    width: 100%;
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #cccccc;
    position: relative;
}
.password_form li img,
.RPRU_bottom .phoneAndcode li img {
    width: 15px;
    height: 20px;
    vertical-align: middle;
}
.password_form li .el-input,
.RPRU_bottom .phoneAndcode li .el-input {
    width: calc(100% - 25px);
}
.password_form li .el-input::-webkit-input-placeholder,
.RPRU_bottom .phoneAndcode li .el-input::-webkit-input-placeholder {
    color: #bfc3cb;
}
.denglu {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    cursor: pointer;
}
.center_bottom {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 35px;
    box-sizing: border-box;
}
.center_bottom span,
.center_bottom span label {
    cursor: pointer;
    color: #999999;
    font-size: 14px;
}
.center_bottom span label input {
    vertical-align: bottom;
}
.center_bottom span:active {
    color: #0185df;
}
.rightFunction span:nth-of-type(1) {
    padding-right: 4px;
}
.RPRU {
    width: 100%;
    height: calc(100% - 55px);
}
.RPRU_top {
    width: 100%;
    height: 130px;
    position: relative;
    text-align: center;
}
.RPRU_top div {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}
.RPRU_top p:nth-of-type(1) {
    color: #000000;
    font-size: 22px;
    margin-bottom: 19px;
}
.RPRU_top p:nth-of-type(2) {
    color: #bfc3cb;
    font-size: 16px;
}
.RPRU_bottom {
    padding: 0px 35px;
    box-sizing: border-box;
}
.RPRU_bottom .phoneAndcode .fasongyanzm .el-input {
    width: calc(100% - 110px);
}
.RPRU_bottom .phoneAndcode .fasongyanzm span {
    width: 96px;
    height: 34px;
    display: inline-block;
    border-radius: 4px;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    cursor: pointer;
}
.RPRU_bottom .phoneAndcode .fasongyanzm .fasong {
    background: #0286df;
    color: #ffffff;
}
.RPRU_bottom .phoneAndcode .fasongyanzm .countDown {
    border: 1px solid #dfe4ea;
    color: #c0c4cc;
}
.submtButton {
    width: 100%;
    height: 40px;
    display: block;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    background: #0286df;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 34px;
}
.mimaSeting li {
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #cccccc;
    text-align: left;
}
.mimaSeting li:nth-of-type(1) {
    margin-bottom: 20px;
}
.mimaSeting li input {
    width: 100%;
    margin-top: 15px;
}
.mimaSeting li span {
    color: #000000;
    font-size: 16px;
}
</style>
<style>
.password_form li .el-input .el-input__inner,
.RPRU_bottom .phoneAndcode li .el-input .el-input__inner,
.mimaSeting li .el-input .el-input__inner {
    border: none;
}
.password_form li .el-input .el-input__suffix {
    right: 15px;
}
.fasongyanzm .el-input .el-input__inner,
.mimaSeting li .el-input .el-input__inner {
    padding: 0 15px 0 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/logo.vue